<template>
  <svg
    role="img"
    :aria-label="title"
    class="o-icon o-twitter-icon"
    viewBox="2 2 20 20"
    width="40"
    height="40"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.2894 5.98424C21.5429 6.32111 20.7406 6.54798 19.8986 6.65024C20.7584 6.1269 21.4186 5.29762 21.7289 4.30937C20.9249 4.79404 20.0339 5.14638 19.0854 5.33629C18.327 4.51389 17.2441 4 16.047 4C13.3595 4 11.3847 6.54884 11.9917 9.19478C8.53319 9.01862 5.46611 7.33429 3.41265 4.77428C2.32209 6.67602 2.84708 9.16385 4.70018 10.4237C4.0188 10.4013 3.3763 10.2114 2.8158 9.8943C2.77015 11.8545 4.15237 13.6883 6.15425 14.0965C5.5684 14.2581 4.92675 14.2959 4.2741 14.1687C4.80332 15.8496 6.34024 17.0725 8.1629 17.1068C6.41294 18.5016 4.20816 19.1246 2 18.8599C3.84211 20.0604 6.03083 20.7608 8.38102 20.7608C16.1096 20.7608 20.476 14.1257 20.2123 8.17473C21.0255 7.57748 21.7314 6.83242 22.2894 5.98424Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'TwitterIcon',
  props: {
    title: {
      default: 'Twitter',
      type: String,
    },
  },
}
</script>
